import { Box, Link, Typography } from '@mui/material';
import VerificationStatusIcon from '@features/workspace/components/verification-status-icon';
import logger from '@app/services/logger';

export default function UserVerificationStatus({
  jumioLink,
  isVerified,
  verificationDate,
  isAddressVerified,
  addressVerificationDate,
}: any) {
  const onOpenJumioIDLink = () => {
    logger.debug('Open jumio link', jumioLink);
    window.open(new URL(jumioLink).href, 'JumioExternal');
  };

  return (
    <>
      <Box display="flex" flexDirection="row">
        <Box alignItems="center" display="flex">
          <Box display="flex">
            <VerificationStatusIcon isVerified={isVerified} />
          </Box>
          <Box display="flex">
            {jumioLink ? (
              <Link
                sx={{
                  cursor: 'pointer',
                  textDecoration: 'underline',
                }}
                title="Click to check on Jumio"
                onClick={onOpenJumioIDLink}
              >
                ID document
              </Link>
            ) : (
              <>ID document</>
            )}
          </Box>
          <Box display="flex" ml={1}>
            <Typography className="labelHeader" variant="subtitle2">
              {verificationDate}
            </Typography>
          </Box>
        </Box>
        <Box alignItems="center" display="flex" ml={1}>
          <Box display="flex">
            <VerificationStatusIcon isVerified={isAddressVerified} />
          </Box>
          <Box display="flex">Proof of address</Box>
          <Box display="flex" ml={1}>
            <Typography className="labelHeader" variant="subtitle2">
              {addressVerificationDate}
            </Typography>
          </Box>
        </Box>
      </Box>
    </>
  );
}
